"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Modal = require("@insided/shared/uikit/Modal");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var SendTestEmailModal = function SendTestEmailModal(_ref) {
  var showModal = _ref.showModal,
      onClose = _ref.onClose;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: showModal,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Send test email",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("p", null, "A test email has been sent to your email address:"), (0, _preact.h)("strong", null, (0, _insidedDataStorage.getInsidedData)('user').email)), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Okay, got it",
    variant: "brand",
    size: "medium",
    onClick: onClose,
    "data-track-type": "click",
    "data-element-name": "Okay, got it button"
  })));
};

var _default = SendTestEmailModal;
exports.default = _default;